import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { map } from 'rxjs/operators';

import { Exploatatie } from '../models/holdings.models';
import { environment } from 'src/environments/environment';
import { SortableTable } from './services-table-helper';

@Injectable({
  providedIn: 'root'
})
export class HoldingsTableService extends SortableTable<Exploatatie> {
  private baseUrl = environment.API_URL;

  holdings: Exploatatie[];
  holdingsNumber: number;

  constructor(private http: HttpClient) {
    super();
  }

  getHoldingsAPI(obj) {
    return this.http.post(
      `${this.baseUrl}/companies/`,
      obj
    ).pipe(map((response: any) => {
      this.holdings = response.result;
      this.holdingsNumber = response.count;

      this.paginate();
      this._tables$.next(this.holdings);
      this._total$.next(this.holdingsNumber);

      return response;
    }));
  }

  getHoldingAPI(code: any) {
    return this.http.post(
      `${this.baseUrl}/companies/getCompany/`,
      code
    ).pipe(map((response: any) => {
      return response;
    }));
  }

  addHolding(holdingObj: Exploatatie) {
    return this.http.post(
      `${this.baseUrl}/companies/add/`,
      holdingObj
    ).pipe(map((response: any) => {

      if (this.holdings !== undefined) {
        if (this.holdings.length >= 10) {
          // Add new holding on first place in the array
          this.holdings.unshift(response);
          // Remove last element form the array
          this.holdings.pop();
        } else {
          this.holdings.push(response);
        }

        // Increase total number of holdings
        this.holdingsNumber += 1;
      }
      return response;
    }));
  }

  updateHolding(holdingObj: Exploatatie) {
    return this.http.post(
      `${this.baseUrl}/companies/update/`,
      holdingObj
    ).pipe(map((response: any) => {
      if (this.holdings !== undefined) {
        for (let i = 0; i < this.holdings.length; i++) {
          if (this.holdings[i].code === response.code) {
            this.holdings[i].name = response.name;
            this.holdings[i].status = response.status;
            this.holdings[i].racecontract = response.racecontract;
          }
        }
      }
      return response;
    }));
  }

  downloadHoldingHistoryApi(companyId) {
    return this.http
      .post(
        `${this.baseUrl}/companies/export-istoric/`,
        { comp_id: companyId },
        {
          responseType: 'blob'
        }
      ).pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  deleteHolding(holdingId) {
    return this.http.post(
      `${this.baseUrl}/companies/delete/`,
      { code: holdingId }
    ).pipe(map((response: any) => {

      return response;
    }));
  }

  getHoldingAdmins(obj?) {
    return this.http.post(
      `${this.baseUrl}/company_admin/`,
      obj
    ).pipe(map((response: any) => {

      return response;
    }));
  }

  addHoldingAdmin(obj) {
    return this.http.post(
      `${this.baseUrl}/company_admin/add/`,
      obj
    ).pipe(map(response => {
      return response;
    }));
  }

  updateHoldingAdmin(obj) {
    return this.http.post(
      `${this.baseUrl}/company_admin/update/`,
      obj
    ).pipe(map(response => {
      return response;
    }));
  }

  updateHoldingStatus(obj) {
    return this.http.post(
      `${this.baseUrl}/companies/change-status/`,
      obj
    ).pipe(map(response => {
      return response;
    }));
  }

  exportXLS(obj) {
    return this.http
    .post(
      `${this.baseUrl}/companies/export-xls/`,
      {
        ...obj
      },
      {
        responseType: 'blob'
      }
    ).pipe(map((response: any) => {
      return response;
    }));
  }

  verificareAnimaleAPI(formData) {
    return this.http.post(
        `${this.baseUrl}/animals/verificare-animale-rne/`,
        formData
      ).pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  verificareConsangvinizareAPI(formData) {
    return this.http.post(
        `${this.baseUrl}/animals/verificare-consangvinizare/`,
        formData,
        {
          responseType: 'blob'
        }
      ).pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  registruMonteFatariAPI(formData) {
    return this.http.post(
        `${this.baseUrl}/animals/registru-de-monte-si-fatari/`,
        formData,
        {
          responseType: 'blob'
        }
      ).pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  /**
   * Paginate Method
   */
  private paginate(): void {
    this.totalRecords = this.holdingsNumber;
    this._state.startIndex = (this._state.page - 1) * this.pageSize + 1;
    this._state.endIndex = Number(this.pageSize) + Number(this._state.startIndex - 1);

    if (this._state.endIndex > this.holdingsNumber) {
      this._state.endIndex = this.holdingsNumber;
    }
  }

}
